export default __webpack_public_path__ + "static/media/Brew of Acute Acumen.48e1697e.jpg";